const ApplicationVersion = () => {
    const version = "2.1.20";

    return (
        <div>
            v{version}
        </div>
    )   
}

export default ApplicationVersion;